<template>
  <div>

    <section class="application-create__form">
      <div class="container-xxxl">
        <div class="row">
          <div class="col-xxl-6 offset-xxl-3">
            <div v-for="(projectDeveloper, index) in projectDevelopers" :key="index">
              <h3 class="application__form__title">{{ $lang.app.PLANNER_INFORMATION }}</h3>
              <div class="application__form__block">
                <div class="add__field__list">
                  <div class="add__field__item">
                    <div class="add__field__header">
                      {{ $lang.app[userTypesGetLabelRefByValue(projectDeveloper.type)] }}
                      <button v-if="editable" type="button" :title="$lang.app.DELETE"
                              @click="deleteProjectDeveloper(projectDeveloper)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                        </svg>
                      </button>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="stack__list">
                          <div class="stack__label">{{ $lang.app.TYPE }}</div>
                          <div class="stack__value">{{ $lang.app[userTypesGetLabelRefByValue(projectDeveloper.type)] }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="stack__list">
                          <div class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER_LICENSES }}</div>
                          <div class="stack__value">{{ projectDeveloper.certNumber }}</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="projectDeveloper.files" class="stack__list">
                      <div class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</div>
                      <div class="file__item cursor-pointer"  @click="loadProjectDeveloperFile(projectDeveloper, projectDeveloper.files)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                        </svg>
                        <span class="file__item__name">
                      {{ projectDeveloper.files.filename }}
                    </span>
                      </div>
                    </div>
                    <template v-if="projectDeveloper.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')
                                || projectDeveloper.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')">
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.PIN }}</div>
                        <div class="stack__value">{{ projectDeveloper.person?.pin }}</div>
                      </div>
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                        <div class="stack__value">{{ projectDeveloper.person?.surname }} {{ projectDeveloper.person?.name }} {{ projectDeveloper.person?.patronymic }}</div>
                      </div>
                    </template>
                    <template v-if="projectDeveloper.type === userTypesGetValueByKey('LEGAL_ENTITY')">
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.INN }}</div>
                        <div class="stack__value">{{ projectDeveloper.organization?.inn }}</div>
                      </div>
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.ORG_NAME_RU }}</div>
                        <div class="stack__value">{{ projectDeveloper.organization?.nameRu }}</div>
                      </div>
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.ORG_NAME_KG }}</div>
                        <div class="stack__value">{{ projectDeveloper.organization?.nameKg }}</div>
                      </div>
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                        <div class="stack__value">{{ projectDeveloper.organization?.surname }} {{ projectDeveloper.organization?.name }} {{ projectDeveloper.organization?.patronymic }}</div>
                      </div>
                    </template>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="stack__list">
                          <div class="stack__label">{{ $lang.app.PHONE }}</div>
                          <div class="stack__value">{{ projectDeveloper.phoneNumber }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="stack__list">
                          <div class="stack__label">{{ $lang.app.EMAIL }}</div>
                          <div class="stack__value">{{ projectDeveloper.email }}</div>
                        </div>
                      </div>
                    </div>
                    <button v-if="editable" type="button" class="add__field__edit"
                            @click="editProjectDeveloper(projectDeveloper)">
                      <svg viewBox="0 0 24 24" width="24" height="24">
                        <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                      </svg>
                      {{ $lang.app.EDIT }}
                    </button>
                  </div>
                </div>

                <div v-for="(projectArchitect, index) in projectDeveloper.projectArchitects" :key="index"
                     class="add__field__item">
                  <div class="add__field__header">
                    {{ $lang.app.PROJECT_MAIN_ARCHITECT }}
                    <button v-if="editable" type="button" :title="$lang.app.DELETE"
                            @click="deleteProjectArchitect(projectDeveloper, projectArchitect)">
                      <svg viewBox="0 0 24 24" width="24" height="24">
                        <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                    <div class="stack__value">{{ projectArchitect.surname }} {{ projectArchitect.name }} {{ projectArchitect.patronymic }}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.PHONE }}</div>
                        <div class="stack__value">{{ projectArchitect.phoneNumber }}</div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.EMAIL }}</div>
                        <div class="stack__value">{{ projectArchitect.email }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</div>
                    <div class="stack__value">{{ projectArchitect.certNumber }}</div>
                  </div>
                  <div v-if="projectArchitect.files" class="stack__list mb0">
                    <div class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</div>
                    <div class="file__item cursor-pointer" @click="loadProjectArchitectFile(projectDeveloper, projectArchitect)">
                      <svg viewBox="0 0 24 24" width="24" height="24">
                        <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                      </svg>
                      <span class="file__item__name">
                    {{ projectArchitect.files.filename }}
                  </span>
                    </div>
                  </div>
                  <button v-if="editable" type="button" class="add__field__edit"
                          @click="$emitter.emit('open-applicant-application-architect-edit-modal', {projectDeveloper, projectArchitect})">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                    </svg>
                    {{ $lang.app.EDIT }}
                  </button>
                </div>
                <div v-if="editable" class="input__group">
                  <button type="button" class="button button--full button__icon--left button--default button--bordered button__add__customers__docs"
                          @click="$emitter.emit('open-applicant-application-architect-create-modal', projectDeveloper)">
                    <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                    </svg>
                    <span class="button__text">{{ $lang.app.PROJECT_MAIN_ARCHITECT }}</span>
                  </button>
                </div>
                <ArchitectCreateModal/>
                <ArchitectEditModal/>

                <div v-for="(projectEngineer, index) in projectDeveloper.projectEngineers" :key="index"
                     class="add__field__item">
                  <div class="add__field__header">
                    {{ $lang.app.PROJECT_MAIN_ENGINEER }}
                    <button v-if="editable" type="button" :title="$lang.app.DELETE"
                            @click="deleteProjectEngineer(projectDeveloper, projectEngineer)">
                      <svg viewBox="0 0 24 24" width="24" height="24">
                        <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                    <div class="stack__value">{{ projectEngineer.surname }} {{ projectEngineer.name }} {{ projectEngineer.patronymic }}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.PHONE }}</div>
                        <div class="stack__value">{{ projectEngineer.phoneNumber }}</div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="stack__list">
                        <div class="stack__label">{{ $lang.app.EMAIL }}</div>
                        <div class="stack__value">{{ projectEngineer.email }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</div>
                    <div class="stack__value">{{ projectEngineer.certNumber }}</div>
                  </div>
                  <div v-if="projectEngineer.files" class="stack__list mb0">
                    <div class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</div>
                    <div class="file__item cursor-pointer" @click="loadProjectArchitectFile(projectDeveloper, projectEngineer)">
                      <svg viewBox="0 0 24 24" width="24" height="24">
                        <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                      </svg>
                      <span class="file__item__name">
                    {{ projectEngineer.files.filename }}
                  </span>
                    </div>
                  </div>
                  <button v-if="editable" type="button" class="add__field__edit"
                          @click="$emitter.emit('open-applicant-application-engineer-edit-modal', {projectDeveloper, projectEngineer})">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                    </svg>
                    {{ $lang.app.EDIT }}
                  </button>
                </div>
                <div v-if="editable" class="input__group">
                  <button type="button" class="button button--full button__icon--left button--default button--bordered button__add__customers__docs"
                          @click="$emitter.emit('open-applicant-application-engineer-create-modal', projectDeveloper)">
                    <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                    </svg>
                    <span class="button__text">{{ $lang.app.PROJECT_MAIN_ENGINEER }}</span>
                  </button>
                </div>
                <EngineerCreateModal/>
                <EngineerEditModal/>

              </div>
            </div>
            <div v-if="editable" class="mb-32">
              <button type="button" class="button button--full button__icon--left button--default button--bordered button__add__customers__docs"
                      @click="createProjectDeveloper">
                <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                </svg>
                <span class="button__text">{{ $lang.app.PLANNER_INFORMATION }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="application-create__controls">
      <div class="container-fluid">
        <div class="application-create__controls__wrapper">
          <button type="button" @click="$router.go(-1)" class="button button--cancel">{{ $lang.app.CANCEL }}</button>
          <router-link :to="{name: 'ApplicantApplicationDocumentsDetail', params: {applicationId: application.id}}"
                       class="button button__icon--right">{{ $lang.app.NEXT }}
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
            </svg></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../../helpers/constants/userTypes";
import applicationApi from "../../../../api/applicant/application";
import ArchitectCreateModal from "../../../../components/applicant/application/modals/ArchitectCreateModal.vue";
import EngineerCreateModal from "../../../../components/applicant/application/modals/EngineerCreateModal.vue";
import ArchitectEditModal from "../../../../components/applicant/application/modals/ArchitectEditModal.vue";
import EngineerEditModal from "../../../../components/applicant/application/modals/EngineerEditModal.vue";

export default {
  name: "ApplicantApplicationsPlannersList",
  props: {
    application: Object,
  },
  components: {
    ArchitectCreateModal,
    EngineerCreateModal,
    ArchitectEditModal,
    EngineerEditModal,
  },
  computed: {
    editable() {
      return this.application.actions.some(
          action => action.constName === 'APPLICANT_EDIT_ACTION'
      )
    },
    projectDevelopers() {
      return this.application.projectDevelopers
    },
  },
  methods: {
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,
    editProjectDeveloper(projectDeveloper) {
      this.$router.push({
        name: 'ApplicantApplicationPlannersEdit',
        params: {applicationId: this.application.id, plannerId: projectDeveloper.id}
      })
    },
    createProjectDeveloper() {
      this.$router.push({
        name: 'ApplicantApplicationPlannersCreate',
        params: {applicationId: this.application.id}
      })
    },
    deleteProjectDeveloper(projectDeveloper) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteProjectDeveloper(this.application.id, projectDeveloper.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
    deleteProjectArchitect(projectDeveloper, projectArchitect) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteProjectArchitect(projectDeveloper.id, projectArchitect.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
    deleteProjectEngineer(projectDeveloper, projectEngineer) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteProjectEngineer(projectDeveloper.id, projectEngineer.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
    loadProjectDeveloperFile(projectDeveloper, file) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getProjectDeveloperFile(this.application.id, projectDeveloper.id, file.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
    loadProjectArchitectFile(projectDeveloper, projectArchitect) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getProjectArchitectFile(projectDeveloper.id, projectArchitect.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
    loadProjectEngineerFile(projectDeveloper, projectEngineer) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getProjectEngineerFile(projectDeveloper.id, projectEngineer.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
  },
};
</script>
